import _ from 'lodash';

import { PayoutTypes } from './PayoutDetails';
import { PaymentProviderIdTypes } from './PaymentProviderIdTypes';
import { MoneyMovementOperationTypes } from './MoneyMovementOperationTypes';

export const paymentsConfig = {
  providers: [
    {
      name: 'Your Wallet',
      id: 'wallet-connect',
      enabled: true,
      batchAvailable: false,
      suitableForPayouts: [PayoutTypes.CryptoTransfer],
      suitableForCryptoNetworks: [
        'Polygon',
        'Ethereum',
        'Optimism',
        'Arbitrum',
        'Base',
      ],
      suitableForCurrencies: [
        'ETH',
        'USDC',
        'USDC.native_polygon',
        'USDC.native_arbitrum',
        'USDT',
        'BUSD',
        'DAI',
        'ANT',
        'EURS',
        'GRT',
        'OP',
        'VELA',
        'esVELA',
        'ARB',
      ],
    },
    {
      name: 'Your Wallet',
      id: 'solana-wallet-connect',
      enabled: true,
      batchAvailable: false,
      suitableForPayouts: [PayoutTypes.CryptoTransfer],
      suitableForCryptoNetworks: ['Solana'],
      suitableForCurrencies: ['SOL', 'USDC'],
    },
    // {
    //   name: 'Pay With Exchange',
    //   id: 'mesh',
    //   enabled: true,
    //   batchAvailable: false,
    //   onboardingType: 'app-flow',
    //   suitableForCryptoNetworks: [
    //     'Polygon',
    //     'Ethereum',
    //     'Optimism',
    //     'Arbitrum',
    //     // 'Base',
    //   ],
    //   suitableForCurrencies: [
    //     'ETH',
    //     'USDC',
    //     'USDC.native_polygon',
    //     'USDC.native_arbitrum',
    //     'USDT',
    //     'BUSD',
    //     'DAI',
    //     'ANT',
    //     'EURS',
    //     'GRT',
    //     'OP',
    //   ],
    //   suitableForPayouts: [PayoutTypes.CryptoTransfer],
    // },
    {
      name: 'Fractal Account',
      id: 'fractal-abstract-bank-account',
      enabled: true,
      batchAvailable: false,
      onboardingType: 'customer-service',
      suitableForPayouts: [
        PayoutTypes.CryptoTransfer,
        PayoutTypes.BankTransfer,
      ],
      suitableForCryptoNetworks: ['Polygon'],
      suitableForCurrencies: ['USDC', 'USD', 'EUR'],
    },
    // {
    //   name: 'Aragon App',
    //   id: 'aragon-app',
    //   enabled: true,
    //   batchAvailable: true,
    //   suitableForPayouts: [PayoutTypes.CryptoTransfer],
    //   suitableForCryptoNetworks: ['Polygon', 'Ethereum'],
    //   suitableForCurrencies: [
    //     'ETH',
    //     'USDC',
    //     'USDC.native_polygon',
    //     'USDT',
    //     'BUSD',
    //     'DAI',
    //     'ANT',
    //     'EURS',
    //     'GRT',
    //   ],
    // },
    {
      name: 'Settle With Crypto',
      id: 'bridge-offramp',
      enabled: true,
      isOnrampMethod: false,
      operationType: MoneyMovementOperationTypes.Offramp,
      onboardingType: 'customer-service',
      batchAvailable: false,
      suitableForCurrencies: ['EUR', 'USD'],
      availableDepositNetworks: ['Ethereum', 'Polygon', 'Base', 'Solana'],
      suitableForPayouts: [PayoutTypes.BankTransfer],
    },
    {
      name: 'Settle With Crypto',
      id: PaymentProviderIdTypes.EasyPayOfframpTransfer,
      operationType: MoneyMovementOperationTypes.Offramp,
      enabled: true,
      isOnrampMethod: false,
      onboardingType: 'customer-service',
      batchAvailable: false,
      suitableForCurrencies: ['EUR', 'USD'],
      availableDepositNetworks: ['Ethereum', 'Polygon', 'Base', 'Solana'],
      suitableForPayouts: [PayoutTypes.BankTransfer],
    },
    {
      name: 'Pay with Fiat Currency',
      id: 'bridge-onramp',
      enabled: true,
      isOnrampMethod: true,
      onboardingType: 'customer-service',
      batchAvailable: false,
      suitableForCurrencies: ['USDC', 'USDC.native_polygon'],
      suitableForCryptoNetworks: ['Polygon', 'Ethereum', 'Base'],
      suitableForPayouts: [PayoutTypes.CryptoTransfer],
      availableDepositCurrencies: ['USD', 'EUR'],
      depositRailsByCurrencies: {
        USD: [
          {
            value: 'ach_push',
            label: 'ACH (2-4 working days)',
          },
          {
            value: 'wire',
            label: 'WIRE (1-2 working days)',
          },
        ],
        EUR: [
          {
            value: 'local',
            label: 'SEPA',
          },
        ],
      },
    },
    {
      name: 'Pay with Fiat Currency',
      id: 'easy-pay-onramp',
      isOnrampMethod: true,
      enabled: true,
      onboardingType: 'customer-service',
      batchAvailable: false,
      availableDepositCurrencies: ['USD', 'EUR'],
      suitableForCurrencies: ['USDC', 'USDC.native_polygon'],
      depositRailsByCurrencies: {
        USD: [
          {
            value: 'ach_push',
            label: 'ACH (2-4 working days)',
          },
          {
            value: 'wire',
            label: 'WIRE (1-2 working days)',
          },
        ],
        EUR: [
          {
            value: 'local',
            label: 'SEPA',
          },
        ],
      },
      suitableForCryptoNetworks: ['Polygon', 'Ethereum', 'Base'],
      suitableForPayouts: [PayoutTypes.CryptoTransfer],
    },
    {
      name: 'Settle with Fiat',
      id: 'red-envelope-onramp',
      enabled: true,
      isOnrampMethod: true,
      batchAvailable: false,
      onboardingType: 'customer-service',
      availableDepositCurrencies: ['USD'],
      suitableForCurrencies: ['USDC', 'USDT'],
      suitableForCryptoNetworks: ['Polygon', 'Ethereum'],
      suitableForPayouts: [PayoutTypes.CryptoTransfer],
    },
    {
      name: 'Monerium',
      id: 'monerium',
      enabled: true,
      batchAvailable: false,
      onboardingType: 'app-flow',
      suitableForCurrencies: ['EUR'],
      suitableForPayouts: [PayoutTypes.BankTransfer],
    },
    {
      name: 'Cross-Chain Settle',
      id: PaymentProviderIdTypes.EasyPayCrossChainTransfer,
      enabled: true,
      operationType: MoneyMovementOperationTypes.CrossChainTransfer,
      isOnrampMethod: false,
      batchAvailable: false,
      onboardingType: 'customer-service',
      suitableForCurrencies: ['USDC', 'USDT', 'USDC.native_polygon'],
      suitableForCryptoNetworks: [
        'Polygon',
        'Ethereum',
        'Base',
        'Tron',
        'Solana',
      ],
      suitableForPayouts: [PayoutTypes.CryptoTransfer],
    },
    {
      name: 'Gnosis Safe',
      id: 'gnosis-safe',
      enabled: true,
      batchAvailable: true,
      suitableForPayouts: [PayoutTypes.CryptoTransfer],
      suitableForCryptoNetworks: [
        'Polygon',
        'Ethereum',
        'Optimism',
        'Arbitrum',
        'Base',
      ],
      suitableForCurrencies: [
        'ETH',
        'USDC.native_polygon',
        'USDC.native_arbitrum',
        'USDC',
        'USDT',
        'BUSD',
        'DAI',
        'ANT',
        'EURS',
        'GRT',
        'OP',
        'VELA',
        'esVELA',
        'ARB',
      ],
    },
  ],
};

class PaymentsConfig {
  _config;

  constructor(config: any) {
    this._config = config;
  }

  get(path: any, fallback: any) {
    return _.get(this._config, path, fallback);
  }
}

export const getPaymentsConfig = () => {
  return new PaymentsConfig(paymentsConfig);
};
